import { useSuspenseQuery } from "@tanstack/react-query";
import { type FC, Suspense } from "react";
import type { MetaAdsDisapprovedAdItem } from "shared";
import { Api } from "../../api.config";
import { useCompany } from "../../company/useCompany";
import { Card } from "../../components/Card";
import { QueryKeys } from "../../LinkGen";

const DisapprovedAdsTableInner: FC = () => {
	const company = useCompany();
	const { data: disapprovedAds } = useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.Disapproved(company.id),
		queryFn: () => Api.GetMetaAdsDisapprovedAds().then((r) => r.data),
	});

	if (disapprovedAds.length === 0) {
		return (
			<Card>
				<Card.Header>Disapproved Ads</Card.Header>
				<Card.Body>
					<p className="text-muted" style={{ marginBottom: 0 }}>
						No disapproved ads found.
					</p>
				</Card.Body>
			</Card>
		);
	}

	return (
		<Card>
			<Card.Header>Disapproved Ads ({disapprovedAds.length})</Card.Header>
			<Card.Body style={{ padding: 0 }}>
				<table className="table" style={{ marginBottom: 0 }}>
					<thead>
						<tr>
							<th>Ad Name</th>
							<th>Ad Set</th>
							<th>Campaign</th>
							<th>Rejection Reason</th>
						</tr>
					</thead>
					<tbody>
						{disapprovedAds.map((ad: MetaAdsDisapprovedAdItem) => (
							<tr key={ad.objectId}>
								<td>{ad.name}</td>
								<td>{ad.adSetName || "-"}</td>
								<td>{ad.campaignName || "-"}</td>
								<td>
									<span className="text-danger">{ad.rejectionReason}</span>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</Card.Body>
		</Card>
	);
};

export const DisapprovedAdsTable: FC = () => (
	<Suspense fallback={<p>Loading disapproved ads...</p>}>
		<DisapprovedAdsTableInner />
	</Suspense>
);
